module.exports = __webpack_public_path__ + "img/light.eb0318e7.png";